import {
  exists,
  ReserveGroupBibliography,
  ReserveGroupBibliographyFromJSON
} from '@/api'

export interface ReserveGroup {
  id: number
  name: string
  nameKana: string
  revision: number
  bibliographies: ReserveGroupBibliography[]
}

export function ReserveGroupFromJSON(json: any): ReserveGroup {
  return {
    id: exists(json, 'id') ? json.id : 0,
    name: exists(json, 'name') ? json.name : '',
    nameKana: exists(json, 'name_kana') ? json.name_kana : '',
    revision: exists(json, 'revision') ? json.revision : 0,
    bibliographies: exists(json, 'bibliographies')
      ? json.bibliographies.map(ReserveGroupBibliographyFromJSON)
      : []
  }
}
